import { render, staticRenderFns } from "./clouddeteamange.vue?vue&type=template&id=3672f325&scoped=true"
import script from "./clouddeteamange.vue?vue&type=script&lang=js"
export * from "./clouddeteamange.vue?vue&type=script&lang=js"
import style0 from "./clouddeteamange.vue?vue&type=style&index=0&id=3672f325&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3672f325",
  null
  
)

export default component.exports